import { ContactUsForm } from "../Components/ContactUsForm";
import api from '../Services/api';

export default function ContactUsPage() {
  const handleContactSubmit = async (formData: {
    name: string;
    email: string;
    category: string;
    message: string;
  }) => {
    try {
      // Send form data to the backend API
      await api.post("/contact", formData);
    } catch (error) {
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 flex items-center justify-center">
      <div className="w-full max-w-md px-4 py-8 text-gray-900 dark:text-gray-100">
        <ContactUsForm onSubmit={handleContactSubmit} />
      </div>
    </div>
  );
}
